import { Injector } from "@angular/core";
import { AnalyticsData, _ACTIONS } from "../../providers/analytics";

export function PageTrack(uuidTrack: string, name: string): ClassDecorator {
  return function (constructor: any) {
    const injectorAnalytics = Injector.create([{ provide: AnalyticsData, deps: [] }]);
    const analytics: AnalyticsData = injectorAnalytics.get(AnalyticsData);
    const pageName = name

    const ngOnInit = constructor.prototype.ngOnInit;
    constructor.prototype.ngOnInit = function (...args) {
      analytics.sendPageTrack(pageName, _ACTIONS.enter, uuidTrack);
      ngOnInit && ngOnInit.apply(this, args);
    }

    const ngOnDestroy = constructor.prototype.ngOnDestroy;
    constructor.prototype.ngOnDestroy = function (...args) {
      analytics.sendPageTrack(pageName, _ACTIONS.leave, uuidTrack);
      ngOnDestroy && ngOnDestroy.apply(this, args);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/decorators/analytics.ts